export default "__VITE_ASSET__B6HZK86E__"